<template>
<div>
  <Select :value="value" filterable transfer clearable @input="onInput" @on-change="onChange">
    <Option v-for="item in showList" :value="item.value" :key="item.value">{{ item.txt }}</Option>
  </Select>
</div>
  
</template>

<script>
const dicData = JSON.parse(localStorage.dicData); // 排序的字典 数组结构
const POLICY_STATUS = dicData.POLICY_STATUS; // 主状态
const POLICY_SUB_STATUS = dicData.POLICY_SUB_STATUS; // 子状态

export default {
  props: {
    value: null,
    // 显示的列表 未传时显示全部状态
    valIncludes: {
      type: Array,
      default() {
        return [];
      }
    },
    // 需要过滤的状态数组
    valExcludes: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    const allStatusList = [];
    const mergeStatusList = ['3']; // 需要合并对应子状态的主状态 目前只有pending状态
    POLICY_STATUS.forEach(item => {
      if (mergeStatusList.includes(item.value)) {
        // 需要合并对应子状态
        // 获取当前保单状态对应的子状态
        const subList = POLICY_SUB_STATUS.filter(item2 => {
          // 获取当前保单状态对应的子状态
          const min = item.value + '00';
          const max = item.value + '99';
          return Number(item2.value) >= Number(min) && Number(item2.value) <= Number(max);
        }).map(item2 => ({
          ...item2,
          txt: item.txt + '-' + item2.txt,
          value: item.value + '_' + item2.value
        }));
        console.log('subList', subList)
        allStatusList.push(...subList);
      } else {
        allStatusList.push(item);
      }
    });
    return {
      allStatusList,
      statusArr: []
    };
  },
  computed: {
    showList() {
      let outList = this.allStatusList;
      if (this.valIncludes && this.valIncludes.length) {
        console.log('this.allStatusList', this.allStatusList);
        // 外部如果传入值按外部传入的值过滤显示
        outList = this.allStatusList.filter(item => this.valIncludes.includes(item.value));
        console.log(outList);
      }
      // 外部如果传入需要排除的值按外部传入的值过滤显示
      if (this.valExcludes && this.valExcludes.length) {
        outList = outList.filter(item => !this.valExcludes.includes(item.value));
      }
      return outList;
    }
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
    onChange(e) {
      this.$emit('onChange', e);
      this.$emit('on-change', e);
    }
  }
};
</script>
